module.exports = __webpack_public_path__ + "img/BEE2E9_7E6A53_9AA09C_87837E-256px.4857d214.png";